/* eslint-disable import/no-anonymous-default-export */
import Footer from "../Footer";
import { Container } from "./styles";
import React, { useState } from 'react';
import InlineSVG from "react-inlinesvg";
import usePlugins from "../Plugins/hooks/usePlugins";
import classNames from "classnames";
import Plugins from "./Plugins";
import SudowriteLogo from "../SudowriteLogo";
import { PLUGIN_CREATORS } from "../../../../src/shared/constants";
import { useParams } from "react-router-dom";
import PageNotFound from "../../PageNotFound";

export default ({ openLogin }) => {
  const { slug } = useParams();
  const creator = PLUGIN_CREATORS.find((creator) => creator.slug === slug);
  const [isExpanded, setIsExpanded] = useState(false);


  // Helper function to truncate the description to 50 words
  const truncateDescription = (desc, limit = 30) => { // Default limit set to 10 for demonstration
    const words = desc.split(/\s+/); // Split by any whitespace
    if (words.length > limit) {
      return words.slice(0, limit).join(' ') + '...';
    }
    return desc;
  };

  const toggleDescription = () => setIsExpanded(!isExpanded);

  const LightOrDarkColor = classNames({
    'light': creator.textColor === '#fff',
    'dark': creator.textColor === '#383838',
  });

  if (!creator) {
    return <PageNotFound />;
  }

  const { plugins } = usePlugins({ ids: creator.plugins });

  return (
    <Container>
      <div
        className="creator"
        style={{
          backgroundImage: `url(${creator.backgroundImage})`,
          color: `${creator.textColor}`,
        }}
      >
        <div className={LightOrDarkColor}>
          <SudowriteLogo
            isLink
            className="corner-logo"
            size="x-large"
            style={{ color: creator.textColor }}
          />
        </div>
        <div className="hide-on-mobile"></div>
        <div className="info">
          <div className="subtext">Sudowrite Plugins &middot; Featured Author</div>

          <h1>{creator.name}</h1>
          <div className="description">
            {isExpanded ? creator.description : truncateDescription(creator.description)}
            <span
              onClick={toggleDescription}
              style={{ marginLeft: "10px", cursor: "pointer" }}
            >
              {isExpanded ? "See less" : "See more"}
            </span>
          </div>

          <div className="links">
            {creator.urls.map((url) => {
              const urlObj = new URL(url.href);
              const domain = urlObj.hostname.replace("www.", "");

              return (
                <a
                  href={url.href}
                  style={{
                    color: `${creator.textColor}`,
                    border: `2px solid ${creator.transparentColor}`,
                  }}
                >
                  <p className={LightOrDarkColor}>
                    <InlineSVG
                      fill={`${creator.textColor}`}
                      src="/assets/out.svg"
                    />{" "}
                    {url.title}
                  </p>
                  <span>{domain}</span>
                </a>
              );
            })}
          </div>

          <div className="plugins-inline">
            <h2>{creator.firstName}'s plugins:</h2>
            <Plugins
              plugins={plugins}
            />
          </div>
        </div>

        <img
          className="image"
          src={`${creator.portrait}`}
        />
        <div
          className="plugins-tray"
          style={{
            background: `${creator.trayColor}`,
          }}
        >
          <h2>{creator.firstName}'s plugins:</h2>

          <Plugins
            plugins={plugins}
          />
        </div>
        <div
          className="border"
          style={{
            color: `${creator.textColor}`,
            border: `2px solid ${creator.transparentColor}`,
          }}
        ></div>
      </div>

      <div className="footer-container">
        <Footer />
      </div>
    </Container>
  );
};
